/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LegacyTask/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LegacyTask({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables/CreateNewTask/Content/LegacyTask"
  
}) {
let eventActionDataCreateTaskValueData = fromData.useDataValue({ viewPath,
context: 'event_action',
path: 'data.create_task',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="event_action.data.create_task"
 isSelected={eventActionDataCreateTaskValueData}
 onClick={onClick}
 text="Create legacy task when skipped"
/>
{children}
</React.Fragment>)
}